import { render, staticRenderFns } from "./PowerBiCard.vue?vue&type=template&id=0507343e&"
import script from "./PowerBiCard.vue?vue&type=script&lang=js&"
export * from "./PowerBiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports